"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postalCode = exports.cvv = exports.expirationYear = exports.expirationMonth = exports.expirationDate = exports.number = exports.creditCardType = void 0;
var creditCardType = require("credit-card-type");
exports.creditCardType = creditCardType;
var card_number_1 = require("./card-number");
Object.defineProperty(exports, "number", { enumerable: true, get: function () { return card_number_1.cardNumber; } });
var expiration_date_1 = require("./expiration-date");
Object.defineProperty(exports, "expirationDate", { enumerable: true, get: function () { return expiration_date_1.expirationDate; } });
var expiration_month_1 = require("./expiration-month");
Object.defineProperty(exports, "expirationMonth", { enumerable: true, get: function () { return expiration_month_1.expirationMonth; } });
var expiration_year_1 = require("./expiration-year");
Object.defineProperty(exports, "expirationYear", { enumerable: true, get: function () { return expiration_year_1.expirationYear; } });
var cvv_1 = require("./cvv");
Object.defineProperty(exports, "cvv", { enumerable: true, get: function () { return cvv_1.cvv; } });
var postal_code_1 = require("./postal-code");
Object.defineProperty(exports, "postalCode", { enumerable: true, get: function () { return postal_code_1.postalCode; } });
var cardValidator = {
    creditCardType: creditCardType,
    number: card_number_1.cardNumber,
    expirationDate: expiration_date_1.expirationDate,
    expirationMonth: expiration_month_1.expirationMonth,
    expirationYear: expiration_year_1.expirationYear,
    cvv: cvv_1.cvv,
    postalCode: postal_code_1.postalCode,
};
exports.default = cardValidator;
